import gsap from 'gsap'
import LocomotiveScroll from 'locomotive-scroll'
import { breakpointUp } from './helpers/breakpoints'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import {setUpHeader} from './helpers/header'
import { setUpNavigation } from './helpers/navigation'
import { setUpFirstBlock} from './sections/first'
import { initializePopups } from './helpers/popups'
import { initializeCookies } from './helpers/cookies'
import { loadElementLazyImage } from './helpers/lazy-load'
import { setupExploreSlider } from './sections/explore-slider'
import { setupParallaxImages } from './helpers/paralax'

gsap.registerPlugin(ScrollTrigger)

let scrollerElement = '.smooth-scroll'
let scroller = null
let locoScroll = null

if ($(scrollerElement).length) {

  $(window).on('load', function (e) {

    //do not use locomotive scroll in mobile devices
    if(breakpointUp('lg')) {

      scroller = '#scroll'

      locoScroll = new LocomotiveScroll({
        el: document.querySelector(scrollerElement),
        smooth: true,
        tablet: { smooth: true },
        smartphone: { smooth: true },
        lerp: 0.07,
        reloadOnContextChange: true,
      })
      //locoScroll.stop()

      // Stop Locomotive when scroll dropdown
      if (window.innerWidth > 1200) {
        $('.select-items').mouseover(function () { locoScroll.stop() })
        $('.select-items').mouseout(function () { locoScroll.start() })
      }

      //-- For Gsap Animations
      locoScroll.on('scroll', () => ScrollTrigger.update())
      ScrollTrigger.scrollerProxy(scroller, {
        scrollTop (value) {
          return arguments.length ? locoScroll.scrollTo(value, 0, 0) : locoScroll.scroll.instance.scroll.y
        },
        getBoundingClientRect () {
          return {
            top: 0,
            left: 0,
            width: window.innerWidth,
            height: window.innerHeight,
          }
        },
        pinType: document.querySelector(scroller).style.transform ? 'transform' : 'fixed',
      })
      ScrollTrigger.addEventListener('refresh', () => locoScroll.update())
      ScrollTrigger.refresh()


      //-- Lazy Load For Locoscroll, Stop Video
      let lazyArr = [...document.querySelectorAll('.lazy')]
      let addClassArr = [...document.querySelectorAll('.js-add-class-when-in-screen')]
      let contentBlock = $('#content-block')
      let stoppedVideo = 0
      let mainVideo = document.querySelector('.js-hero-video')
      let vH = window.innerHeight
      locoScroll.on('scroll', function(e){
        // lazy load
        lazyArr.forEach(function(el){
          if (checkIfInScreen(el)){
            loadElementLazyImage($(el))
            lazyArr.splice( $.inArray(el, lazyArr), 1 );
          }
        })

        // Add class to elements with class .js-add-class-when-in-screen,
        // add class from attribute  data-add-class
        addClassArr.forEach(function(el){
          let addClass = $(el).data('add-class')
          if (addClass) {
            if (checkIfInScreen(el)) {
              $(el).addClass(addClass)
            } else {
              $(el).removeClass(addClass)
            }
          }
        })


        if (contentBlock.offset().top < 0 - vH + 200) {
          if (stoppedVideo === 0) mainVideo.pause()
          stoppedVideo = 1
        } else {
          if (stoppedVideo === 1) mainVideo.play()
          stoppedVideo = 0
        }


      })

      // setInterval(function (e){
      //   updateLocoScroll()
      // }, 3000)


    }



    //--- run functions
    setUpHeader(locoScroll)
    setUpFirstBlock(locoScroll)
    setUpNavigation(locoScroll)
    initializePopups(locoScroll)
    initializeCookies(locoScroll)
    setupExploreSlider(scroller, locoScroll)
    setupParallaxImages(scroller, locoScroll)

  })

}


//Update scroll container height, scroll trigger values
function updateLocoScroll() {
  ScrollTrigger.refresh()
  if(!locoScroll) return false
  locoScroll.update()

}

export function startLocoScroll(){
  locoScroll.start()
}
export function stopLocoScroll(){
  locoScroll.start()
}

$(window).on('load', function (e) {

  setTimeout(function (){
    updateLocoScroll()
  }, 1000)

})

export { updateLocoScroll }



function checkIfInScreen(el){
  let vH = window.innerHeight
  let elTop = $(el).offset().top
  let elScreenPosition = 'bottom'
  if ($(el).data('screen-pos') === 'top') elScreenPosition = 'top'
  let offset = 0
  if ($(el).data('screen-offset') !== undefined) offset = $(el).data('screen-offset')

  if (elScreenPosition === 'top'){
    if (elTop - offset < 0){
      return true
    }
  } else {
    if (elTop - offset < vH + 200 && elTop > 0) {
      return true
    }
  }
  return false
}
